import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';
import { trackMetaPageView } from '../../utils/metaConversions';

const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route change
    const pageTitle = document.title;
    const pageUrl = window.location.href;
    trackPageView(pageUrl, pageTitle);
    trackMetaPageView(pageUrl);
  }, [location]);

  return children;
};

export default AnalyticsProvider;